<template>
  <div class="model">
    <div :itemscope="undefined" itemtype="http://schema.org/Product">
      <meta itemprop="sku" :content="pageData?.model?.id" />
      <meta itemprop="model" :content="pageData?.model?.name" />
      <meta itemprop="description" :content="metaDescription" />
      <meta itemprop="ratingValue" :content="dataBtns.rating" />
      <div
        class="model-main l-container"
        :class="!isCurrency ? 'no-model_price' : ''"
      >
        <div
          v-if="!isCurrency"
          class="no-model_price-subtitle-mobile"
          itemprop="name"
        >
          {{ h1text }}
        </div>
        <div v-if="!isCurrency" class="no-model_price-title-mobile">
          {{ isLoadPage ? '' : 'товар закончился' }}
        </div>

        <div class="line line-desktop">
          <h1 itemprop="name" class="heading-m">
            {{ h1text }}
          </h1>
          <div class="line-inner">
            <div class="price heading-l">
              <template v-if="isCurrency">
                <Currency :value="pageData?.model?.price_info?.min" />
                —
                <Currency :value="pageData?.model?.price_info?.max" />
              </template>
              <template v-else>
                <p class="no-model_price-header heading-l">
                  {{ isLoadPage ? '' : 'товар закончился' }}
                </p>
              </template>
            </div>
            <div class="position-model-btns__wrapper">
              <ModelBtns
                :seo-data="dataBtns"
                :page-data="pageData"
                :review-component="reviewComponent"
                :href-review-component="hrefReviewComponent"
                @add-review="addReview"
              />
            </div>
          </div>
        </div>
        <div :class="{ 'model-information__wrapper': isCurrency }">
          <div
            :class="{ 'model-picture-container-zoom': isZoom }"
            class="model-picture-container"
          >
            <div v-if="isCurrency" class="model-information__image">
              <div style="min-width: 310px" />
              <SliderModelImport
                :images="pageData?.model?.additional_images"
                :name="pageData?.model?.name"
                @set-zoom="setIsZoom"
              />
            </div>
            <div v-else class="no-model_price__wrapper">
              <div class="no-model_price__wrapper-info">
                <div
                  :class="[
                    'no-model_price__info',
                    { 'has-linked-models': linkedModels?.length > 0 },
                  ]"
                >
                  <div class="no-model_price__image">
                    <slider-no-model :image="noImageSlider" />
                  </div>
                  <div class="no-model_price__text">
                    <div
                      v-if="
                        pageData?.model?.price_info &&
                        pageData?.model?.price_info?.last_price
                      "
                      class="no-model_price__last-cost-wrapper"
                    >
                      <Currency
                        class="no-model_price__last-cost price-s"
                        :value="pageData?.model?.price_info?.last_price"
                      />
                      <span class="no-model_price__last-text body-s-medium"
                        >Последняя цена</span
                      >
                    </div>
                    <div class="name-model body-m-medium">{{ h1text }}</div>
                    <div
                      class="name-model__more body-l-regular link"
                      @click="toRoute('specifications')"
                    >
                      Читать характеристики
                    </div>
                  </div>
                  <div
                    v-if="linkedModels?.length > 0"
                    class="no-model_price__linkedModel"
                  >
                    <UiLinkedModel
                      v-for="(item, index) in linkedModels"
                      :key="`builtInMemoryLinkedModel_${index}`"
                      :add-filter-query="filterQuery"
                      :data="item"
                      :class="index === linkedModels?.length - 1 ? 'last' : ''"
                    />
                  </div>
                  <div
                    v-if="showPreloaderLinkedModel"
                    class="preload-block-wrapper empty-linked-model"
                  >
                    <span class="preload-block-api" />
                  </div>
                </div>
              </div>
              <div
                :class="[
                  'similar-products-with-discounts',
                  { 'no-model_price__l-100': !isCurrency },
                ]"
              >
                <p class="no-model_price-title heading-m">
                  Похожие товары со скидками
                </p>

                <div v-if="!isCurrency">
                  <div v-if="!isNoCurrencyOffers && !isBot">
                    <div class="no-model_price__preloader"></div>
                    <div class="no-model_price__preloader"></div>
                    <div class="no-model_price__preloader"></div>
                  </div>
                  <ModalsPromocodeShopModal
                    v-if="showPromocodeModal"
                    :shop="shopModalInfo"
                    :model="pageData?.model"
                    @close="closePromocodeModal"
                  />
                  <div
                    v-if="isNoCurrencyOffers"
                    class="no-model_price-line"
                  ></div>
                  <ProductCardPrice
                    v-for="(item, index) in isNoCurrencyOffers"
                    :id="`offer_${item.id}`"
                    :key="`${item.id}_${index}`"
                    :highlight-offer="highlightOffer === String(item.id)"
                    :model="item"
                    :position="itemsOffset + index"
                    block-type="model-offers-sale"
                    :class="
                      index === isNoCurrencyOffers?.length - 1
                        ? 'no-currency-last'
                        : ''
                    "
                    @show-promocode-modal="openPromocodeModal"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="isCurrency" class="line line-mobile">
            <div class="mobile-title heading-m" itemprop="name">
              {{ h1text }}
            </div>
            <div v-if="isCurrency" class="price heading-l">
              <template v-if="isCurrency">
                <Currency :value="pageData?.model?.price_info?.min" />
                —
                <Currency :value="pageData?.model?.price_info?.max" />
              </template>
            </div>

            <div v-if="isSpecifications" class="spec-link">
              <ui-ui-link
                font-class="body-m-regular"
                :font-weight="400"
                @click="toRoute('specifications')"
              >
                Все характеристики
              </ui-ui-link>
            </div>
          </div>
          <div v-if="isCurrency" class="info">
            <PageModelComponentDescription
              :class="{ 'l-mobile-mb': pageData?.linkedModels?.length }"
              :is-less-desktop="false"
              :page-data="pageData"
              :seo-data="seoData"
              :show-preloader-linked-model="showPreloaderLinkedModel"
              :show-preloader-description-base="showPreloaderDescriptionBase"
              @to-route="toRoute"
              @go-to="goToId"
            />
            <PopularModelImport
              :offers="offersTop3.offers"
              :count="offersCount"
              :is-monitoring="!!monitoring"
              @go-to="goToHTMLElement"
              @to-route="toRoute"
              @open-quick-view="showQuickViewOffer = true"
              @open-monitoring-sticker-modal="openMonitoringStickerModal"
            />
          </div>
        </div>
      </div>
      <div ref="startRef" />
      <ModelNavigation
        ref="tabs"
        :count="{
          offers: (pageData?.offers && pageData?.offers?.offer_count) || 0,
          videos: pageData?.model?.video_count,
          voprosy: pageData?.model?.questions_count,
          otzyvy: pageData?.model?.review_count,
        }"
        :active-sections="pageData?.navSections"
        :questions_count="pageData?.model?.questions_count"
        :price_review_count="pageData?.model?.price_review_count"
        :active="activeTab"
        :page-route="pageRoute"
        :class="!isCurrency ? 'no-currency-nav' : ''"
        @to-route="toRoute"
        @change-data="(e) => $emit('change-data', e)"
      />
      <DelayHydration>
        <div class="tabs-blocks">
          <base-tab
            v-if="pageData?.active === 'base'"
            :seo-data="seoData"
            :page-data="pageData"
            :is-mobile="isMobile"
            :is-tablet="isMobile"
            :is-presets="isPresets"
            :monitoring="monitoring"
            :is-currency="Boolean(isCurrency)"
            :is-bot="isBot"
            :is-go-to-review="isGoToReview"
            @to-route="toRoute"
            @change-data="(e) => $emit('change-data', e)"
            @change-model-sort-top3="SortingIsChangingOffersTop3"
            @hide-component="(e) => hideComponent(e)"
            @open-monitoring-modal="openMonitoringModal"
            @open-monitoring-sticker-modal="openMonitoringStickerModal"
            @open-how-monitoring-modal="showHowMonitoringModal = true"
          />
          <div v-else>
            <component
              :is="showComponent"
              :key="showComponent"
              ref="infoTab"
              :is-base-tab="isBaseTab"
              :page-data="pageData"
              :seo-data="seoData"
              :is-tablet="isMobile"
              :is-mobile="isMobile"
              :model-id="pageData?.model?.id"
              :name="pageData?.model?.name"
              :brand="pageData?.model?.brand"
              :spec="pageData?.specifications"
              :show-all="isBot"
              :model="pageData?.model"
              :pictures="pageData?.pictures"
              :changed-page="pageData?.changedPage"
              :videos="pageData?.videos"
              :offer-filters="pageData?.filters"
              :offers="pageData?.offers"
              :per-page="20"
              :wide-pagination="false"
              :is-currency="isCurrency"
              when-visible
              @to-route="toRoute"
              @change-data="(e) => $emit('change-data', e)"
              @change-model-sort-top3="SortingIsChangingOffersTop3"
            />
          </div>
        </div>
      </DelayHydration>
      <client-only>
        <LazyModalsQuickViewOffer
          v-if="showQuickViewOffer && pageData?.offers?.list[0]"
          :model="pageData?.offers?.list[0]"
          @order="openOrderModal(pageData?.offers?.list[0], 1, 'pu-offer')"
          @close="showQuickViewOffer = false"
        />
      </client-only>
      <client-only>
        <LazyModalsViewPhoto
          v-if="viewPhoto"
          :photos="pageData?.model?.additional_images"
          :index-view-image="indexViewImage"
          :name="pageData?.model?.name"
          @close="closeViewPhoto"
        />
      </client-only>
      <client-only>
        <LazyModalsMonitoringModal
          v-if="showMonitoringModal"
          :offers="showMonitoringModal"
          @close="closeMonitoringModal"
        />
      </client-only>
      <client-only>
        <LazyModalsHowMonitoringModal
          v-if="showHowMonitoringModal"
          @close="showHowMonitoringModal = false"
        />
      </client-only>
      <client-only>
        <LazyModalsMonitoringStickerModal
          v-if="monitoringModalInfoOffer && monitoring"
          :monitoring="monitoring"
          :offer="monitoringModalInfoOffer"
          @open-monitoring-modal="openMonitoringModal"
          @close="closeMonitoringStickerModal"
        />
      </client-only>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import { useHistoryStore } from '~/stores/history';
import { useTimeCalculation } from '~/composition/useTimeCalculation';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import SliderModelImport from '~/components/page-model/page-model-slider/PageModelSlider.vue';
import PopularModelImport from '~/components/popular-model/PopularModel.vue';
import Currency from '~/components/ui/currency/Currency.vue';
import BaseTab from '~/components/page-model/tabs/base/base-tab.vue';
import AccessorTab from '~/components/page-model/tabs/accessories/accessories-tab.vue';
import OffersTab from '~/components/page-model/tabs/offers/offers-tab.vue';
import CharacteristicsTab from '~/components/page-model/tabs/characteristics/characteristics-tab.vue';
import ReviewsTab from '~/components/page-model/tabs/model-reviews/model-reviews-tab.vue';
import QuestionsTab from '~/components/page-model/tabs/model-questions/model-questions-tab.vue';
import VideosTab from '~/components/page-model/tabs/videos-tab/VideosTab.vue';
import PriceChartTab from '~/components/page-model/tabs/priceChart/PriceChartTab.vue';
import ModelBtns from '~/components/page-model/model-btns/ModelBtns.vue';
import { API } from '~/api/api';
import { useAnalyticsStore } from '~/stores/analytics';
import {
  getLinkedModels,
  getModelMonitoring,
  modelsSpecification,
  modelsSpecificationBase,
} from '~/api/pageModel';
import { timeOrAction } from '~/utils/timeOrAction';
import type {
  ModelOfferItem,
  ModelPriceMonitoringType,
  ShopInfo,
} from '~/interfaces/api';
import { useModalsStore } from '~/stores/modals';
import { timeOrActionTimer } from '~/common/const';
import type { PageDataModel } from '~/interfaces/app';

const tabsArr = [
  'base',
  'accessories',
  'offers',
  'specifications',
  'otzyvy',
  'voprosy',
  'videos',
  'price-chart',
];
const showComponent = shallowRef<any>(null);
const noImageSlider = computed(() => {
  return props.pageData?.model?.additional_images &&
    props.pageData?.model?.additional_images?.length > 0
    ? props.pageData?.model?.additional_images[0]
    : null;
});
const setShowComponent = (name: string) => {
  switch (name) {
    case 'accessories':
      showComponent.value = AccessorTab;
      break;
    case 'offers':
      showComponent.value = OffersTab;
      break;
    case 'specifications':
      showComponent.value = CharacteristicsTab;
      break;
    case 'otzyvy':
      showComponent.value = ReviewsTab;
      break;
    case 'voprosy':
      showComponent.value = QuestionsTab;
      break;
    case 'videos':
      showComponent.value = VideosTab;
      break;
    case 'price-chart':
      showComponent.value = PriceChartTab;
      break;
    default:
      showComponent.value = null;
  }
};
const props = defineProps({
  data: {
    type: Object as any,
    required: true,
  },
  seoData: {
    type: Object as any,
    required: true,
  },
  pageData: {
    type: Object as any,
    required: true,
  },
});
const emit = defineEmits(['change-data']);
const globalStore = useGlobalStore();
const modalsStore = useModalsStore();
const historyStore = useHistoryStore();
const analyticsStore = useAnalyticsStore();
const router = useRouter();
const route = useRoute();
const { $retailRocketProductEvent, $retailRocketRender } = useNuxtApp();
const tabs = ref<any>();
const isBot = computed(() => globalStore.isBot);
const showQuickViewOffer = ref(false);
const viewPhoto = ref(false);
const mediaStore = useMediaQueryStore();
const isBaseTab = ref(true);
const isZoom = ref(false);
const showHowMonitoringModal = ref(false);
const monitoring = ref<ModelPriceMonitoringType | string>('');
const indexViewImage = ref(0);
const isNoCurrencyOffers = ref([]);
const isLoadPage = computed(() => Object.keys(props.pageData)?.length === 0);
const showMonitoringModal = ref<ModelOfferItem[] | null>(null);
const monitoringModalInfoOffer = ref<ModelOfferItem | null>(null);
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const hideComponent = (e: string) => {
  const res = props.pageData?.navSections.filter((key: string) => {
    return key !== e;
  });
  emit('change-data', {
    key: 'navSections',
    data: res,
  });
};
const filterQuery = ref<string>('');
const linkedModels = computed(() => props.pageData?.linkedModels);
const activeTab = ref<string>(
  route.path.endsWith('otzyvy/')
    ? 'otzyvy'
    : route.path.endsWith('voprosy/')
    ? 'voprosy'
    : props.pageData?.active !== 'otzyvy' ||
      props.pageData?.active !== 'specifications'
    ? props.pageData?.active
    : 'base'
);
globalStore.updateSeoTexts({
  shop_count: props.pageData?.model?.shop_count || 0,
  price_min: props.pageData?.model?.price_info?.min || 0,
  price_max: props.pageData?.model?.price_info?.max || 0,
  offer_count: props.pageData?.model?.offer_count || 0,
});
const highlightOffer = computed(
  () => props.pageData?.model?.highlightOffer || ''
);
const pageActive = ref<number>(props.pageData?.offers?.page || 1);
const itemsOffset = computed((): number => (pageActive.value - 1) * 11);
const shopModalInfo = ref(null);
const showPromocodeModal = ref(false);
const showPreloaderLinkedModel = ref(!props.pageData?.linkedModels);
const showPreloaderDescriptionBase = ref(!props.pageData?.baseSpec);
const isSpecifications = computed(
  () =>
    props.pageData &&
    props.pageData.specifications &&
    props.pageData.specifications.length > 0
);
const openPromocodeModal = (v: ShopInfo) => {
  shopModalInfo.value = v;
  showPromocodeModal.value = true;
};
const closePromocodeModal = () => {
  shopModalInfo.value = null;
  showPromocodeModal.value = false;
};
const dataBtns = computed(() => ({
  description: props.seoData?.page?.description,
  image: props.pageData?.model?.image,
  title: props.seoData?.page?.title,
  review_count: props.pageData?.model?.review_count || 0,
  questions_count: props.pageData?.model?.questions_count || 0,
  rating: props.pageData?.model?.rating,
}));

const isPresets = computed<boolean>(
  () =>
    (!activeTab.value ||
      activeTab.value === 'base' ||
      activeTab.value === 'otzyvy') &&
    !!props.pageData?.presets?.length
);

const reviewComponent = computed(() => {
  if (!props.pageData?.model?.review_count) return 'div';
  return activeTab.value !== 'otzyvy' ? 'a' : 'div';
});

const hrefReviewComponent = computed(() => {
  return reviewComponent.value === 'div'
    ? undefined
    : pageRoute.value + '/otzyvy/';
});

const h1text = computed(() => props.seoData?.page?.h1 || '');
const metaDescription = computed(
  () => props.seoData?.page?.description || h1text.value
);

const pageRoute = ref<string>(
  (route.path.endsWith('/') ? route.path.slice(0, -1) : route.path).replace(
    /\/(otzyvy|voprosy)\/?$/,
    ''
  )
);

const offersTop3 = {
  id: null as number | null,
  offers: { list: [] as PageDataModel[] },
};

const scrollIntoView = () => {
  setTimeout(() => {
    if (tabs.value?.$el) {
      tabs.value.$el.scrollIntoView({
        behavior: 'smooth',
        alignToTop: 'true',
      });
    }
  }, 1000);
};
const openOrderModal = (
  offer: ModelOfferItem,
  position = 1,
  blockType = ''
) => {
  showQuickViewOffer.value = false;
  modalsStore.setData({
    name: 'order',
    data: {
      offer,
      position,
      blockType,
    },
  });
};
const toRoute = (routeName: string) => {
  if (!tabsArr.includes(routeName)) return;

  isBaseTab.value = routeName === 'base' || routeName === 'otzyvy';
  // todo пока отключил, так как решаем что делать с глобальным роутингом, который обновляет все запросы при смене url
  if (
    routeName === 'otzyvy' &&
    activeTab.value !== 'otzyvy' &&
    props.pageData?.model?.price_review_count
  ) {
    const { href } = router.resolve({
      path: pageRoute.value + '/otzyvy/',
      query: {
        ...route.query,
        page: undefined,
      },
    });
    window.history.replaceState({}, '', href);
  } else if (
    routeName === 'voprosy' &&
    activeTab.value !== 'voprosy' &&
    props.pageData?.model?.price_review_count
  ) {
    const { href } = router.resolve({
      path: pageRoute.value + '/voprosy/',
      query: {
        ...route.query,
        page: undefined,
      },
    });
    window.history.replaceState({}, '', href);
  } else if (activeTab.value === 'otzyvy' && routeName !== 'otzyvy') {
    const { href } = router.resolve({
      path: pageRoute.value + '/',
      query: {
        ...route.query,
        page: undefined,
      },
    });
    window.history.replaceState({}, '', href);
  } else if (activeTab.value === 'voprosy' && routeName !== 'voprosy') {
    const { href } = router.resolve({
      path: pageRoute.value + '/',
      query: {
        ...route.query,
        page: undefined,
      },
    });
    window.history.replaceState({}, '', href);
  }

  activeTab.value = routeName;
  setShowComponent(routeName);
  emit('change-data', {
    key: 'active',
    data: routeName,
  });

  if (
    (routeName === 'voprosy' || routeName === 'otzyvy') &&
    globalStore.ScrollToQuestion
  ) {
    // при клике на вопросе, на кнопочку 'еще' (mobile+tablet) переход с подскроллом к нужному вопросу
    window.scrollTo({ top: 0 });
    setTimeout(() => {
      if (!globalStore.ScrollToQuestion) return;
      const stq = '#' + globalStore.ScrollToQuestion;
      const el = document.querySelector(stq.toString());
      window.scrollTo({
        top: el?.getBoundingClientRect().top - 44,
        behavior: 'smooth',
      });
      globalStore.setScrollToQuestion(null);
    }, 1000);
  } else {
    setTimeout(() => {
      startRef.value.scrollIntoView();
    }, 50);
  }
  setTimeout(
    () => {
      if ($retailRocketRender) $retailRocketRender(true);
    },
    routeName === 'offers' ? 700 : 300
  );
};
const startRef = ref();
const isGoToReview = ref(false);

const addReview = () => {
  if (props.pageData?.model?.review_count) {
    toRoute('otzyvy');
  } else {
    isGoToReview.value = true;
    setTimeout(() => {
      isGoToReview.value = false;
    }, 1500);
  }
};
const isCurrency = computed<boolean>(() => {
  return (
    props.pageData?.model?.price_info &&
    props.pageData?.model?.offer_count &&
    !!(
      props.pageData?.model?.price_info.min ||
      props.pageData?.model?.price_info.max
    )
  );
});

const offersCount = computed(() => {
  if (
    !props.pageData?.offers?.offer_count &&
    props.pageData?.offers?.offer_count !== 0
  )
    return -1;
  if (props.pageData?.offers?.offer_count === 0) return 0;
  return Number(props.pageData?.offers?.offer_count) || 1;
});

const goToHTMLElement = (
  element: HTMLElement,
  isDouble = false,
  time = 2000
) => {
  if (element && element.offsetTop) {
    setTimeout(() => {
      window.scrollTo({
        top: element.offsetTop - 70,
        behavior: 'smooth',
      });
      // Для двух проскроллов. При первом проскролле подгружаются лейзи компонеты, и первый скролл попадает "мимо"
      if (isDouble) {
        setTimeout(() => {
          window.scrollTo({
            top: element.offsetTop - 70,
            behavior: 'smooth',
          });
        }, 700);
      }
    }, time);
  }
};
const goToId = (id: string) => {
  if (!id) return;
  if (id === 'model-similar' && activeTab.value !== 'base') {
    toRoute('base');
    setTimeout(() => {
      const element = document.querySelector(`#${id}`) as HTMLElement;
      goToHTMLElement(element, false, 100);
    }, 700);
  } else {
    const element = document.querySelector(`#${id}`) as HTMLElement;
    goToHTMLElement(element, false, 100);
  }
};

const setIsZoom = (value: boolean) => {
  isZoom.value = value;
};

const getOffersIsNoCurrency = async () => {
  try {
    const res = await API.get(
      `/models/${props.pageData.model?.id}/best_offers`,
      {
        params: {
          region_id: globalStore.region.id || 1,
          sem: globalStore.sem || undefined,
          device: globalStore.device,
          adult: globalStore.adult,
          split: analyticsStore?.additional?.split,
        },
      }
    );
    if (res?.data) {
      isNoCurrencyOffers.value = res.data.slice(0, 3);
    }
  } catch (e) {
    console.error('get best_offers error', e);
  }
};
const getModelPriceMonitoringData = async () => {
  if (!isCurrency.value) return;
  monitoring.value =
    (await getModelMonitoring(
      {
        region_id: globalStore.region.id || 1,
        sem: globalStore.sem || undefined,
        device: globalStore.device,
      },
      props.pageData.model?.id
    )) || '';
};
const openMonitoringModal = () => {
  closeMonitoringStickerModal();
  if (typeof monitoring.value === 'object' && monitoring.value !== null) {
    showMonitoringModal.value = monitoring.value.offers || null;
  } else {
    showMonitoringModal.value = null;
  }
};
const openMonitoringStickerModal = (offer: ModelOfferItem) => {
  if (!monitoring.value) return;
  monitoringModalInfoOffer.value = offer;
};
const closeMonitoringStickerModal = () => {
  monitoringModalInfoOffer.value = null;
};
const closeMonitoringModal = () => {
  showMonitoringModal.value = null;
};
if (isBot.value && props.pageData?.monitoring)
  monitoring.value = props.pageData?.monitoring;
onMounted(() => {
  const paramsGoto: string = String(route.query?.goto) || '';
  if (!import.meta.env.SSR && !isCurrency.value) getOffersIsNoCurrency();
  if (!import.meta.env.SSR && paramsGoto) {
    if (
      paramsGoto === 'specifications' &&
      props.pageData?.navSections?.includes('specifications')
    ) {
      setTimeout(() => {
        toRoute('specifications');
      }, 1500);
    } else if (paramsGoto === 'add_review') {
      const review = document.querySelector('#add_review') as HTMLElement;
      goToHTMLElement(review, true);
    } else if (paramsGoto.includes('offer_')) {
      const offer_id = paramsGoto.split('offer_');
      if (offer_id[1]) {
        const findOffer = document.querySelector(
          `#offer_${offer_id[1]}`
        ) as HTMLElement;
        goToHTMLElement(findOffer);
        const pageData = {
          ...props.pageData?.model,
          highlightOffer: offer_id[1],
        };
        emit('change-data', {
          key: 'model',
          data: pageData,
        });
      }
    } else if (paramsGoto.includes('offers')) {
      const findOffers = document.querySelector(`.model-offers`) as HTMLElement;
      goToHTMLElement(findOffers);
    }
  }
  if (!import.meta.env.SSR && props.pageData?.model?.id) {
    if ($retailRocketProductEvent)
      $retailRocketProductEvent(props.pageData?.model?.id);
    if ($retailRocketRender) $retailRocketRender();
  }
  nextTick(async () => {
    if (!isBot.value && !props.pageData?.linkedModels) {
      const linkItems = await timeOrAction(
        getLinkedModels(props.pageData?.model?.id),
        timeOrActionTimer
      );
      const isObjectExist = Object.keys(linkItems)?.length > 0;
      if (isObjectExist && 'data' in linkItems) {
        emit('change-data', {
          key: 'linkedModels',
          data: linkItems?.data,
        });
        showPreloaderLinkedModel.value = false;
      }
      if ((linkItems && linkItems?.success === false) || !isObjectExist) {
        showPreloaderLinkedModel.value = false;
      }
    }

    if (!isBot.value && !props.pageData?.baseSpec) {
      const specificationBase = await timeOrAction(
        modelsSpecificationBase(props.pageData?.model?.id),
        timeOrActionTimer
      );
      const isObjectExistBase = Object.keys(specificationBase)?.length > 0;
      if (isObjectExistBase && 'data' in specificationBase) {
        emit('change-data', {
          key: 'baseSpec',
          data: specificationBase?.data,
        });
        showPreloaderDescriptionBase.value = false;
      }
    }

    if (!isBot.value && !props.pageData?.specifications) {
      const specificationModel = await timeOrAction(
        modelsSpecification(props.pageData?.model?.id, isBot.value),
        timeOrActionTimer
      );
      const isObjectExistModel = Object.keys(specificationModel)?.length > 0;
      if ('data' in specificationModel)
        if ('success' in specificationModel?.data) {
          emit('change-data', {
            key: 'specifications',
            data: [],
          });
          return;
        }

      if (isObjectExistModel && 'data' in specificationModel) {
        emit('change-data', {
          key: 'specifications',
          data: specificationModel?.data,
        });
      }
    }
  });
  if (!isBot.value) getModelPriceMonitoringData();
});

if (props.pageData?.active === 'otzyvy') {
  setShowComponent('otzyvy');
}
if (props.pageData?.active === 'specifications') {
  setShowComponent('specifications');
}

if (props.pageData?.active === 'voprosy') {
  setShowComponent('voprosy');
}
onBeforeMount(() => {
  if (
    ['otzyvy', 'specifications', 'voprosy'].includes(props.pageData?.active)
  ) {
    scrollIntoView();
  }
  historyStore.addHistory(props.pageData?.model);
});
onBeforeUnmount(() => {
  if (window?.curentReviewsTab) window.curentReviewsTab = undefined;
});
useSeoMeta({
  title: `${props.seoData?.page?.title}`,
  ogTitle: `${props.seoData?.page?.title}`,
  description: `${props.seoData.page.description}`,
  ogDescription: `${props.seoData.page.description}`,
});
const closeViewPhoto = () => {
  indexViewImage.value = 0;
  viewPhoto.value = false;
};
// Сохраняет сод. блока "суперпродавец", меняя его только при смене сортировки
const SortingIsChangingOffersTop3 = () => {
  offersTop3.id = null;
};
watch(
  () => props.pageData?.offers,
  () => {
    if (
      (!offersTop3.id || offersTop3.id !== props.pageData?.model?.id) &&
      props.pageData.offers?.offer_count
    ) {
      offersTop3.id = props.pageData?.model?.id;
      offersTop3.offers = props.pageData?.offers;
    }
  },
  { immediate: true, deep: true }
);
useTimeCalculation();
</script>
<style lang="scss" scoped src="./PageModelScss.scss" />
